import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import { clsx as cn } from 'clsx';
import { ACCORDION_SIZE_PARAMS } from '../../constants';
import * as styles from './styles.module.css';

/**
 * Отдельный айтем внутри Accordion
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var AccordionItem = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var title = _ref.title,
    content = _ref.content,
    icon = _ref.icon,
    open = _ref.open,
    handleClick = _ref.handleClick,
    size = _ref.size,
    index = _ref.index;
  var _ACCORDION_SIZE_PARAM = ACCORDION_SIZE_PARAMS[size],
    Title = _ACCORDION_SIZE_PARAM.Title,
    ArrowIcon = _ACCORDION_SIZE_PARAM.ArrowIcon;
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    className: styles['container'],
    children: [/*#__PURE__*/_jsxs("button", {
      "data-testid": "accordion-item-".concat(index),
      className: cn(styles['header-container'], styles["size-".concat(size)]),
      type: "button",
      "aria-expanded": open,
      onClick: handleClick,
      children: [icon && /*#__PURE__*/_jsx("div", {
        className: cn(styles['icon'], styles["size-".concat(size)]),
        "aria-hidden": true,
        children: icon
      }), /*#__PURE__*/_jsxs("div", {
        className: styles['title-and-arrow'],
        children: [/*#__PURE__*/_jsx(Title, {
          fontWeight: "bold",
          children: title
        }), /*#__PURE__*/_jsx("div", {
          className: cn(styles['arrow'], styles["size-".concat(size)], _defineProperty({}, styles['active'], open)),
          "aria-hidden": true,
          children: /*#__PURE__*/_jsx(ArrowIcon, {})
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      role: "region",
      className: cn(styles['content'], styles["size-".concat(size)], _defineProperty({}, styles['active'], open)),
      children: content
    })]
  });
});
AccordionItem.displayName = 'AccordionItem';